export default __webpack_public_path__ + "static/media/Illustration.cf3227c9.png";